import {QueryCommand} from "xmgoing-server";
import SysConfigUtils from "@/utils/sysConfigUtils";
import {StorageUtils} from 'xmgoing-utils';

/**
 * 加载html的信息
 * @param routeUrl
 */
const loadHtmlHelp=function (routeUrl,helpHtml,backFun){
  const queryCommand = new QueryCommand({
    showTip:false,
    errorFlag:false,
    url: '/api/pe-portal/explainDoc/getByPath',
    method: 'GET'
  })
  return queryCommand.executeQuery({
    successFun:(res)=>{
      if(res&&res.explainDoc){
        helpHtml.value=res.explainDoc;
        backFun&&backFun();
      }
    }, params: {path:routeUrl,type:'menu'}})
}

const initEditorImgDom = function () {
  // 初始化图片点击行为（由 mounted 和 watch 触发）
  const editorContainer = document.querySelector('.help-body-content');
  if (!editorContainer) return
  const images = editorContainer.querySelectorAll('img');
  images.forEach(img => {
    img.style.cursor = 'pointer';
    img.style.border = '1px solid #dfdfdf';
    // img.removeEventListener('click',()=>{});
    img.addEventListener('click', (e) => {
      window.open((e.target as HTMLImageElement).src, '_blank')
    })
  })
}


export function useIconHelp(){
  const visible=ref(false);
  const helpHtml:any=ref('');

  /**
   * 打开帮助中心
   */
  const openHelpCenter=function (){
    window.open(SysConfigUtils.docCenterUrl);
  }

  //打开界面帮助抽屉
  const openPageHelp = function () {
    helpHtml.value='';
    const url=window.location.href;
    let routeUrl=url.split(`${location.host}`)[1];
    if(StorageUtils.getSessionItem("curMenuResourceUrl")){
      routeUrl=StorageUtils.getSessionItem("curMenuResourceUrl")+"";
    }
    loadHtmlHelp(routeUrl,helpHtml,()=>{
      setTimeout(()=>{
        initEditorImgDom()
      },300)
    });
    visible.value=true;
  }

  onMounted(()=>{
    window.appObj.openPageHelp=openPageHelp;
  })

  return {
    openHelpCenter,
    helpHtml,
    openPageHelp,
    visible
  }
}
